import FormBuilderModel from "../../../../common/models/tracked/formBuilderModel";
import {PermitteeType} from "~/enums/permitteeType";
import Guid from "~/helpers/guid";
import {TagColor} from "~/enums/tagColor";
import ThirdPartyCompleter from "../formElements/templates/thirdPartyCompleter";
import Notification from "../notifications/notification";
import IRepo from "../../../../common/interfaces/repo";
import FormElement from "../formElements/formElement";
import Repo from "../../../../common/state/modules/repo";
import {RecipientType} from "../../../../common/enums/recipentType";
import {IRecipient} from "../../../../common/interfaces/notificationInterfaces";
import {DocumentOwnerType} from "../../../../common/enums/documentOwnerType";
import {userActivationStatusDisplay} from "~/deactivatable";

export default class Recipient extends FormBuilderModel implements IRecipient  {
  client_id: string = Guid.create();
  reference_id: string = null;
  reference_type: number = null;
  recipient_type: RecipientType = null;
  [key: string]: any;
  except = ['form', 'createEmbeddedObject', 'first_name', 'last_name', 'name', 'activation_status'];

  static repo: IRepo<Recipient> = new Repo<Recipient>('recipients', Recipient);

  update(props): this {
    Object.getOwnPropertyNames(props).forEach(key => {
      this[key] = props[key];
    });
    return this;
  }

  get rootName(): string {
    return 'recipients';
  }

  get isCollectionRoot(): boolean {
    return true;
  }

  get notification(): Notification {
    return this.parent;
  }

  get tagColor(): string {
    return TagColor[this.reference_type];
  }

  get display() {
    switch (this.reference_type) {
      case PermitteeType.originalSubmitter:
        if (this.rootModel.form.form_owner_type === DocumentOwnerType.individual) {
          return 'Original Submitter';
        } else {
          return 'Entity Original Submitter';
        }
      case PermitteeType.entityOwner:
        return 'Entity Owner';
      case PermitteeType.allApprovers:
        return 'All Approvers';
      case PermitteeType.allCompleters:
        return 'All Completers';
      case PermitteeType.stepCompleters:
        return 'Current Step Completers';
      default:
        return this._display();
    }
  }

  get _display() {
    switch (this.reference_type) {
      case PermitteeType.group:
        return () => this.name;
      case PermitteeType.user:
        return () => `${userActivationStatusDisplay(this)}`;
      case PermitteeType.thirdParty:
        return () => this.thirdPartyReference.referenceNameOrDefault;
      case PermitteeType.lookupField:
        return () => this.lookupFieldReference?.referenceNameOrDefault;
      default:
        return () => this.reference_id;
    }
  }

  get thirdPartyReference(): ThirdPartyCompleter {
    // on creation of notification, it is not attached
    if (this.parent.isAttached) {
      return this.parent.parent.referenceableThirdPartyElements.find(tp => tp.client_id === this.reference_id);
    } else {
      return <ThirdPartyCompleter>FormElement.repo.find(this.reference_id);
    }
  }

  get lookupFieldReference() {
    return this.parent.workflowStep.referenceableLookupObjectModelFields.find(lf => lf.client_id === this.reference_id);
  }

  get isLegacyConfig(): boolean {
    return this.reference_type === PermitteeType.user;
  }

  get legacyConfigTooltip(): string | null {
    if (!this.isLegacyConfig) return null;

    return 'This is a legacy configuration. Once you remove this user, you can only use undo to add this individual user back.';
  };
}
